import React from 'react';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';

export const CitationView: React.FC<NodeViewProps> = ({ node }) => {
  const citationRef = String(node.attrs.citation_ref || '').trim();
  const sourceTitle = String(node.attrs.source_title || citationRef || 'Source');
  const sourceSnippet = String(node.attrs.source_snippet || '').trim();
  const citationNumber = node.attrs.citation_number;

  return (
    <NodeViewWrapper as="span" className="citation-wrapper">
      <button
        type="button"
        className="citation-superscript"
        title={sourceSnippet ? `${sourceTitle}\n${sourceSnippet}` : sourceTitle}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!citationRef) {
            return;
          }
          window.dispatchEvent(
            new CustomEvent('curious:scroll-to-source', {
              detail: { citation_ref: citationRef },
            }),
          );
        }}
      >
        [{citationNumber || '?'}]
      </button>
    </NodeViewWrapper>
  );
};
